import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 p-3 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "col-md-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
      _createElementVNode("h5", null, "Ajouter Bon de Retour (Client)")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("label", null, "Client :", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              options: _ctx.clientList,
              modelValue: _ctx.client,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event)),
              label: "store"
            }, {
              option: _withCtx(({ city_return, store, nb_colis }) => [
                city_return
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(store) + " (" + _toDisplayString(city_return) + ") - ( " + _toDisplayString(nb_colis) + " colis)", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(store) + " " + _toDisplayString(city_return) + " - ( " + _toDisplayString(nb_colis) + " colis)", 1))
              ]),
              _: 1
            }, 8, ["options", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.auth.can('ADD_BR_C'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addReturnNote && _ctx.addReturnNote(...args)))
              }, " Ajouter "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}